import {Button} from "reactstrap";
import React, {useState} from "react";
import DynamicForm from "./dynamicForm";
import ModalComponent from "../../atoms/Modal";

const optionsCategories = [
  {
    value: 'Platinum',
    label: 'Platinum'
  },
  {
    value: 'Gold',
    label: 'Gold'
  },
  {
    value: 'Black',
    label: 'Black'
  }
]

const optionsTypeContact = [
  {
    value: 'Web',
    label: 'Web'
  },
  {
    value: 'Convencional',
    label: 'Convencional'
  },
  {
    value: 'Celular',
    label: 'Celular'
  },
  {
    value: 'Whatsapp',
    label: 'Whatsapp'
  }
]


const optionsTypeField = [
  {value: 'email', label: 'Email'},
  {value: 'phonenumber', label: 'Número de Teléfono'},
  {value: 'position', label: 'Posición'},
  {value: 'terms', label: 'Términos'},
  {value: 'icon', label: 'Ícono'},
  {value: 'logo', label: 'Logo'},
  {value: 'document', label: 'Documento'},
  {value: 'categories', label: 'Categorías'}, //pendiente
  {value: 'type', label: 'Tipo de contacto'},
  {value: 'message', label: 'Mensaje'},
  {value: 'title', label: 'Título'}
]

const structureFile = (key: string, title: string) => ({
  key: `${key}`,
  type: "file",
  title: `${title}`,
  column: "6",
  validators: "2",
  placeHolder: `Ingresar ${title}`,
  callbackOnChanged: "saveFiles"
})

const structureByTypeField: any = {
  email: {
    key: "email",
    type: "text",
    title: "Email",
    column: "6",
    validators: "2",
    placeHolder: "Ingresar el email"
  },
  phonenumber: {
    key: "phonenumber",
    type: "text",
    title: "Número de Teléfono",
    column: "6",
    validators: "2",
    placeHolder: "Ingresar el número de teléfono"
  },
  position: {
    key: "position",
    type: "text",
    title: "Posición",
    column: "6",
    validators: "2",
    placeHolder: "Ingresar la posición"
  },
  terms: {
    key: "terms",
    type: "text",
    title: "Términos",
    column: "6",
    validators: "2",
    placeHolder: "Ingresar los términos"
  },
  icon: structureFile('icon', 'Icono'),
  logo: structureFile('logo', 'Logo'),
  document: structureFile('document', 'Documento'),
  type: {
    key: "type",
    type: 'select',
    title: "Tipo de contacto",
    column: "6",
    validators: "2",
    placeHolder: "Ingresar los términos",
    options: optionsTypeContact,
    isMulti: false,
    isClearable: false,
  },
  message: {
    key: "message",
    type: "text",
    title: "Mensaje",
    column: "6",
    validators: "2",
    placeHolder: "Ingresar el mensaje"
  },
  title: {
    key: "title",
    type: "text",
    title: "Título",
    column: "6",
    validators: "2",
    placeHolder: "Ingresar el título"
  },
  categories: {
    key: "categories",
    title: "Categorias",
    placeHolder: "Agregar categorias",
    type: 'select',
    validators: 2,
    options: optionsCategories,
    isMulti: true,
    isClearable: true,
    column: 12,
  },
}
const typeFieldStructure = [
    {
      "key": "type",
      "title": "Tipo del campo",
      "placeHolder": "Seleccione el tipo del campo",
      "type": 'select',
      "validators": {
        "required": true,
      },
      "options": optionsTypeField,
      "isMulti": false,
      "isClearable": true,
      "column": 6,
    },

  ]

const submitProps = {
  class: "btn btn-outline-success custom-toggle mb-3",
  text: 'Guardar Campo'
}
const FormBuilder = ({setChildForm, childForm}: any) => {

  const [showForm, setShowForm] = useState<boolean>(false)

  const saveField = (data: any) => {
    setChildForm([...childForm, ...[structureByTypeField[data.type]]])
    setShowForm(false)
  }

  return (
    <>
      {childForm && <DynamicForm structure={childForm.map((field: any) => ({ ...field, disabled: true}) )} hideSubmitButton/>}
      <Button
        type="button"
        className="btn btn-outline-success custom-toggle mb-3"
        onClick={() => setShowForm(true)}
      >
        <i className="ri-add-line align-bottom me-1"></i> Agregar Campo
      </Button>

      <ModalComponent show={showForm} setOpen={setShowForm} title={'Agregar Campo'} size="lg">
        <DynamicForm
          structure={typeFieldStructure}
          submitProps={submitProps}
          onSubmit={saveField}
        />
      </ModalComponent>
    </>

  );
};


export default FormBuilder;
